import styled from 'styled-components';
import { GROOM, BRIDE } from '../../utils/constants';

const LetterSection = () => {
  const weddingInfo = [GROOM, BRIDE];

  return (
    <StyledSection id="greeting">
      <h2 className="a11y-hidden">모시는 글</h2>
      <StyledP>
        푸른 나무가 짙어지는 6월.
        <br />
        서로의 그늘이 되어줄 두 사람이 하나가 됩니다.
      </StyledP>
      <StyledP>
        햇살처럼 따뜻한 사랑으로 걸어갈 이 길에
        <br />
        소중한 당신을 초대합니다.
      </StyledP>
      <StyledUl>
        {weddingInfo.map((info, index) => {
          const parents = info.parents;
          return (
            <li key={index}>
              <p>
                <div>
                  {parents.father.name} • {parents.mother.name}
                  <span>의 {info.child}</span>
                </div>
                {info.name.slice(1)}
              </p>
            </li>
          );
        })}
      </StyledUl>
    </StyledSection>
  );
};

const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 4rem 3rem;
`;

const StyledP = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
`;

const StyledUl = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 2rem;
  border-left: 0.5rem solid var(--primary);
  font-size: 1.6rem;
  line-height: 2.2rem;
  font-weight: 600;
  margin-top: 2rem;

  span {
    font-size: 1.3rem;
    font-weight: 400;
  }

  p {
    display: flex;
  }

  div {
    width: 16rem;
  }
`;

export default LetterSection;
